import { SerializableObject } from '../../common-react/core';

/**
 * A single fragment of an HS code alternate. The Mobiz duties API returns the HS code broken
 * into fragments (chapter, heading, subheading) that together build up the full 6-8 digit code.
 */
export interface IHsCodeFragment {
	code: string;
	description: string;
	type: string;
}

export interface IHsCodeDescription {
	friendly: string;
	full: string;
	fullTruncated: string;
	htsItem: string;
}

/**
 * A single candidate HS code returned by the duties calculation.
 */
export interface IHsCodeAlternate {
	probabilityMass: number;
	subheadingAlternate: {
		code: string;
		codeType: string;
		description: IHsCodeDescription;
		fragments: IHsCodeFragment[];
	};
}

/**
 * Response returned by the Mobiz `calculate-duties` endpoint. It contains a single
 * classification result whose `alternates` are the candidate HS codes for the query.
 *
 * @see https://en.wikipedia.org/wiki/Harmonized_System
 */
export class HsClassificationCalculateResponse extends SerializableObject {
	public data: {
		classificationsCalculate: {
			id: string;
			name: string;
			categories: string[];
			alternates: IHsCodeAlternate[];
		}[];
	};
}
